import { Field } from 'formik';
import React, { FC, ReactElement } from 'react';
import Textarea from 'src/shared-components/TextareaInput/Textarea';

interface Props {
  name: string;
  label?: string | ReactElement;
  required?: boolean;
  placeholder?: string;
}

const ReviewFormField: FC<Props> = ({ label, name, required, placeholder }) => {
  return (
    <Field name={name} required={required}>
      {({ field, meta }) => {
        const isRegularFieldError = meta.touched && meta.error;
        return (
          <div className="flex flex-col w-full space-y-[18px]">
            <div className="flex flex-col space-y-0.5">
              <Textarea
                isRequired={required}
                title={label}
                value={meta.value}
                isWrong={isRegularFieldError}
                placeholder={placeholder}
                {...field}
              />
              {isRegularFieldError && (
                <p className="fs-caption-reg text-vermilion">{meta.error}</p>
              )}
            </div>
          </div>
        );
      }}
    </Field>
  );
};

export default ReviewFormField;
